// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"PlataformasAsignar_spinnerContainer__6xb+q","botonAdd":"PlataformasAsignar_botonAdd__QC3BU"};